var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRytrLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M431.977 307.891C408.656 276.891 368.344 264.297 329.055 277.57L214.945 327.141C198.359 334.344 184.508 346.18 174.805 361.445L9.4844 621.75C-12.6953 666.133 5.35159 720.305 49.7422 742.516C74.1328 754.711 104.367 754.914 130.219 743.453C154.828 732.578 172.813 712.57 179.586 688.547L426 349.906C439.242 339.945 441.906 321.133 431.977 307.891Z",
    fill: "#FFD54F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.992 752.008H179.992V872.008C179.992 905.148 206.859 932.008 239.992 932.008C273.133 932.008 299.992 905.148 299.992 872.008C299.992 905.148 326.859 932.008 359.992 932.008C393.133 932.008 419.992 905.148 419.992 872.008V752.008H299.992Z",
    fill: "#FFD54F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844 452H789.195L467.398 296.008L200.992 649.406L904 752.008L964 512.008L904 452H844Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.773 837.258C189.055 839.711 186.492 842.32 183.789 844.086L107.594 900.602C97.7578 908.367 83.6016 908.711 72.7969 901.141C61.9844 893.57 57.461 880.148 61.3985 868.25L88.4453 777.32C89.1797 774.172 90.7578 770.883 92.4766 768.422L176.039 753.688L190.773 837.258Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.039 753.695L190.773 837.258C189.047 839.711 186.492 842.32 183.789 844.086L107.594 900.602C97.7578 908.367 83.6015 908.711 72.789 901.141L176.039 753.695Z",
    fill: "#FFB300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.375 173.735L603.75 247.461L520.187 262.196L505.453 178.633L557.07 104.907C566.71 91.141 585.093 87.9066 598.851 97.5395L648.007 131.954C661.765 141.594 665.007 159.977 655.375 173.735V173.735Z",
    fill: "#555555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.375 173.735L603.75 247.461L520.187 262.196L623.429 114.75L648 131.953C661.765 141.594 665.007 159.977 655.375 173.735Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.4921 768.438L505.492 178.609L603.797 247.438L190.797 837.266L92.4921 768.438Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.648 802.852L554.641 213.024L603.789 247.438L190.797 837.266L141.648 802.852Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.992 632.008C160.289 632.008 119.992 672.297 119.992 722.008C119.992 771.711 160.289 812.008 209.992 812.008H442.891L476.07 828.586C532.851 856.976 596.453 872.008 660 872.008C723.547 872.008 791.148 856.976 847.922 828.586L934 785.539V632.008H209.992Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M947.413 814.564L1011.87 778.213C1019.5 773.912 1024 767.116 1024 759.892V474.812C1024 462.218 1010.57 452 993.999 452H903.999V794.158C903.999 811.113 927.468 822.145 947.413 814.564V814.564Z",
    fill: "#666666"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRytrLogo);
export default __webpack_public_path__ + "static/media/rytr-logo.71e54c9cd8213d4f6353507661289eba.svg";
export { ForwardRef as ReactComponent };